import React, { useState, useEffect, useContext } from 'react'
import cookie from 'react-cookies'
import { isMobile } from 'react-device-detect'
import history from '../../../history'

import liveIcon from '../../../assets/mainScreen/liveIcon.svg'
import planIcon from '../../../assets/mainScreen/planIcon.svg'
import progressIcon from '../../../assets/mainScreen/progressIcon.svg'
import trenningIcon from '../../../assets/mainScreen/trenningIcon.svg'
import settingsIcon from '../../../assets/mainScreen/settingsIcon.svg'
import calculatorIcon from '../../../assets/mainScreen/calculator.svg'
import waterIcon from '../../../assets/waterReminder/water.svg'
import conferencesIcon from '../../../assets/conferencesScreen/conferences-icon.svg'
import dietModuleIcon from '../../../assets/DietModuleAssets/dietModuleSvg.svg'
import dietOn from '../../../assets/DietModuleAssets/dietOn.svg'
import dietOff from '../../../assets/DietModuleAssets/dietOff.svg'
import SettingsMenu from './SettingsMenu/SettingsMenu.jsx'

import { getUserData, getTrainingDays } from '../../../Api/backendApi'
import { getAllUserWatchedVideos } from '../../../Api/videoApi'

import AppContext from '../../../context/appContext'

import {
  NavigationBarContainer,
  NavElement,
  SvgElement,
  NavElementName,
  Tooltip,
} from './NavigationBarStyle'

const NavigationBar = () => {
  // Get user data
  const [userData, setUserData] = useState({})
  // const [userTraining, setUserTraining] = useState({})
  // const [userWatchedVideos, setUserWatchedVideo] = useState({})
  const appContext = useContext(AppContext)

  const getUser = async () => {
    if (appContext.appState.user == undefined) {
      const result = await getUserData()

      setUserData(result)
    } else {
      setUserData(appContext.appState.user)
    }
  }

  // const getTraining = async () => {
  //   const result = await getTrainingDays()

  //   setUserTraining(result)
  // }

  // const getWatchedVideos = async () => {
  //   const result = await getAllUserWatchedVideos()

  //   setUserWatchedVideo(result)
  // }

  useEffect(() => {
    ;(async () => {
      getUser()
      // getTraining()
      // getWatchedVideos()
    })()
  }, [])

  const changeLocation = (location) => {
    history.push(location)
  }

  const logout = async () => {
    await cookie.remove('accessToken', { path: '/' })
    await cookie.remove('refreshToken', { path: '/' })

    setTimeout(() => {
      window.location.href = '/'
    }, 100)
  }

  const [isSettingsMenuOpen, setSettingsMenuOpen] = useState(false)

  return (
    <NavigationBarContainer>
      <NavElement trenning onClick={() => changeLocation('/trening')}>
        <SvgElement src={trenningIcon} />
        <NavElementName>Trening</NavElementName>
      </NavElement>

      <NavElement
        trenning
        onClick={() =>
          userData && userData.diet_panel_access
            ? changeLocation('/dieta/wybierz-diete')
            : null
        }
        data-tip={
          !isMobile && userData && !userData.diet_panel_access
            ? 'Wykup subskrypcję by odblokować panel diet.'
            : ''
        }
        data-multiline="true"
      >
        <SvgElement
          src={dietOff}
          diet
          isDisabled={userData && !userData.diet_panel_access}
        />
        <NavElementName>Diety</NavElementName>
      </NavElement>

      <NavElement plan onClick={() => changeLocation('/plan-treningowy')}>
        <SvgElement src={planIcon} />
        <NavElementName>Plan</NavElementName>
      </NavElement>
      <NavElement progress onClick={() => changeLocation('/postepy')}>
        <SvgElement src={progressIcon} />
        <NavElementName>Postępy</NavElementName>
      </NavElement>
      {/* <NavElement live onClick={() => changeLocation('/live')}>
        <SvgElement src={liveIcon} />
        <NavElementName>Live</NavElementName>
      </NavElement> */}
      <NavElement live onClick={() => changeLocation('/treningi-wspolne')}>
        <SvgElement src={conferencesIcon} />
        <NavElementName>Treningi wspólne</NavElementName>
      </NavElement>

      <NavElement
        calculator
        className="calculator"
        onClick={() => changeLocation('/kalkulator')}
      >
        <SvgElement src={calculatorIcon} calculator />
        <NavElementName>Kalkulator BMR</NavElementName>
      </NavElement>
      <NavElement
        calculator
        className="calculator"
        onClick={() => changeLocation('/picie-wody')}
      >
        <SvgElement src={waterIcon} water />
        <NavElementName>Picie wody</NavElementName>
      </NavElement>
      {/* <NavElement plan onClick={() => changeLocation('/plan-treningowy')}>
            <SvgElement src={chatIconSvg} />
            <NavElementName>Chat</NavElementName>
          </NavElement> */}
      <NavElement
        settings
        className="settings"
        onClick={() => setSettingsMenuOpen(!isSettingsMenuOpen)}
      >
        <SvgElement settings src={settingsIcon} />
        <NavElementName>Ustawienia</NavElementName>
      </NavElement>
      {isSettingsMenuOpen && (
        <SettingsMenu
          closeMenu={() => setSettingsMenuOpen(!isSettingsMenuOpen)}
          isVisible={isSettingsMenuOpen}
          changeLocation={changeLocation}
          logout={logout}
          // userMail={'mail@mail.com'}
          // user={userData ? userData : null}
          // trainingDays={userTraining ? userTraining.trainingDays : null}
          // allWatchedVids={userWatchedVideos ? userWatchedVideos : null}
          activeSubscriptionEndTime={'20.20.20'}
          // userId={userData ? userData.id : null}
          updateUserSubLocalChange={false}
          // isUserNewsletterSub={
          //   userData ? userData.is_newsletter_subscriber : null
          // }
        />
      )}
      <Tooltip className="tooltip" type="info" />
    </NavigationBarContainer>
  )
}

export default NavigationBar
